import { CommApiInstance } from "Utils/CommApiInstance";

const RsvdInfoApi = async (
    gameSvcCd:string|null,
) => {
    return await CommApiInstance.post(`${gameSvcCd}/rsvd_info`,{
        apiBody:{
        }
    })
    .then((Resp) => Resp.data);
}
export default RsvdInfoApi;
